import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MARKS } from "@/components/PayMethods";

const base = "h-11 rounded-md font-semibold text-sm flex items-center justify-center gap-2 transition-[background-color,transform] duration-200 active:scale-[0.98] disabled:opacity-60";

export function LandingPlanPay({ planKey, total, destacado, onPay, loading, oferta }) {
  const { t } = useTranslation();
  const spin = (m) => loading === `${planKey}:${m}`;
  if (planKey === "gratuito") {
    return (
      <button type="button" onClick={() => onPay(planKey)} data-testid="plan-free-cta"
        className={`${base} w-full bg-emerald-500 hover:bg-emerald-600 text-white`}>
        {t("home.pricing.freeCta")}
      </button>
    );
  }
  const btn = (m, cls, content) => (
    <button type="button" onClick={() => onPay(planKey, m)} disabled={!!loading} data-testid={`plan-pay-${m}-${planKey}`} className={`${base} ${cls}`}>
      {spin(m) ? <Loader2 className="w-4 h-4 animate-spin" /> : content}
    </button>
  );
  return (
    <div className="space-y-2" data-testid={`plan-pay-${planKey}`}>
      {btn("tarjeta", `w-full ${oferta ? "h-auto min-h-11 py-2 px-3 text-center leading-tight " : ""}${destacado ? "bg-[#0A2540] hover:bg-[#031B33] text-white" : "bg-sky-50 hover:bg-sky-100 text-[#034694] border border-sky-200"}`,
        oferta ? <span data-testid="plan-pay-oferta-pro">{oferta.boton}</span>
          : <>{t("home.pricing.payCard")} <span className="inline-flex items-center gap-1 rounded bg-white px-1.5 py-0.5 text-xs">{MARKS.visa}{MARKS.mastercard}</span></>)}
      <p className="text-[11px] text-slate-500 text-center leading-snug" data-testid={`plan-pay-note-${planKey}`}>{oferta ? oferta.nota : t("home.pricing.payNote", { total })}</p>
    </div>
  );
}
